import  { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useCurrentTeacher from "../../../hooks/useCurrentTeacher";
import Filters from "../Filters";
import useCategories from "../../../hooks/useCategories";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const ListPodCats = () => {
  const navigate=useNavigate()
  const {search,setSearch,category,setCategory,categories}=useCategories()
  const {teacher}=useCurrentTeacher()
  const [podcastsCourses, setPodCatsCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
        if (!teacher?.id) return; 
        setLoading(true); // start loading
      
        fetch(`${BASE_URL}/courses/podcasts/?teacher_id=${teacher.id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            'Content-Type': 'application/json',
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
        })
          .then(res => res.json())
          .then(data => {
            if (Array.isArray(data)) setPodCatsCourses(data);
            else if (data.results && Array.isArray(data.results)) setPodCatsCourses(data.results);
            else setPodCatsCourses([]);
            setLoading(false); // done loading
          })
          .catch(err => {
            console.error(err);
            setLoading(false);
          });
      }, [teacher?.id]);

  const filteredSearch=podcastsCourses.filter((item)=>item.name.toLocaleLowerCase().includes(search))
  const filteredCourses = filteredSearch.filter(
  item => !category || item.category_name === category
);


  return (
    <>
      <div className="container mx-auto p-6">
 {/* Header */}
  <div className="flex justify-between items-center mb-8">
    <div>
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
          </svg>
        </div>
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">PodCast Library</h1>
          <p className="text-sm text-gray-500 mt-1">Browse our collection of educational podcast videos</p>
        </div>
      </div>
    </div>
    <button
      className="px-6 py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-2 shadow-sm"
      onClick={()=>navigate('/teacher/podcasts/upload',{state:{type:'PodCast'}})}
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
      </svg>
      Add New PodCast
    </button>
  </div>

        

      <Filters search={search} setSearch={setSearch} category={category} setCategory={setCategory} categories={categories}/>

       
       <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
  {loading
  ? Array.from({ length: 6 }).map((_, idx) => (
      <div
        key={idx}
        className="bg-white rounded-xl border border-gray-200 overflow-hidden flex flex-col h-full animate-pulse"
      >
        {/* Video Area */}
        <div className="w-full h-48 bg-gray-200" />

        <div className="p-5 flex flex-col flex-1">
          
          {/* Top badges row */}
          <div className="flex justify-between mb-3">
            <div className="h-6 w-20 bg-gray-200 rounded-lg" />
            <div className="h-6 w-16 bg-gray-200 rounded-lg" />
          </div>

          {/* Title */}
          <div className="h-6 bg-gray-200 rounded w-3/4 mb-4" />

          {/* Tags */}
          <div className="flex gap-2 mb-4">
            <div className="h-6 w-24 bg-gray-200 rounded-lg" />
            <div className="h-6 w-24 bg-gray-200 rounded-lg" />
          </div>

          {/* Description lines */}
          <div className="space-y-2 mb-4 flex-1">
            <div className="h-4 bg-gray-200 rounded w-full" />
            <div className="h-4 bg-gray-200 rounded w-5/6" />
            <div className="h-4 bg-gray-200 rounded w-2/3" />
          </div>

          {/* Button */}
          <div className="h-10 bg-gray-200 rounded-xl mt-auto" />
        </div>
      </div>
    ))
  : (

    // 🎥 REAL PODCAST CARDS
    filteredCourses?.map((video) => (
      <div key={video.id} className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-md hover:border-[#0f6abf] transition-all flex flex-col h-full">
        <div className="w-full h-48 bg-black flex items-center justify-center">
              <video
                src={video?.file}
                controls
                className="w-full h-full object-contain"
              />
            </div>
 <div className="p-5 flex flex-col flex-1">
   <div className="flex justify-between">
                <div className="flex items-center gap-2 mb-3">
                <span className="text-xs font-medium px-2.5 py-1 bg-[#e8f0f7] text-[#0f6abf] rounded-lg">
                  {video.course_type}
                </span>
              </div>
              {video.course_type !== 'free' && (
                 <div className="flex items-center gap-2 mb-3">
                <span className="text-xs font-medium px-2.5 py-1 bg-[#e8f0f7] text-[#0f6abf] rounded-lg">
                  ${video.price}
                </span>
              </div>
              )}
               </div>
                 <h3 className="text-lg font-semibold text-gray-900 mb-3">
                {video.name}
              </h3>

              <div className="space-y-3 mb-4 flex-1">
                <div className="flex flex-wrap gap-2">
                  <span className="text-xs px-3 py-1.5 bg-gray-100 text-gray-700 rounded-lg">
                    {video.category_name}
                  </span>
                  <span className="text-xs px-3 py-1.5 bg-gray-100 text-gray-700 rounded-lg">
                    {video.subcategory_name}
                  </span>
                </div>
                <p className="text-sm text-gray-600 line-clamp-3 leading-relaxed">
                  {video.description}
                </p>
              </div>
   <button
                onClick={()=>navigate(`/teacher/podcasts/podcast/${video.learning_type}/${video.id}`)}
              className="w-full flex gap-4 items-center justify-center py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors mt-auto"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
                View Details
              </button>

 </div>


      
      </div>
    ))
  )}
</div>

      </div>

  
    </>
  );
};

export default ListPodCats;
